import React, { useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import BeerCardsGallery from "./beer";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import IconButton from "@mui/material/IconButton";

const App: React.FC = () => {
  const [filter, setFilter] = useState<string>("1");
  const [sort, setSort] = useState<string>("0"); 
  const [open, setOpen] = React.useState(false);

  const handleChangeFilter = (event: SelectChangeEvent) => {
    setFilter(event.target.value);
  };

  const handleChangeSort = (event: SelectChangeEvent) => {
    setSort(event.target.value); 
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="App">
      <header className="header">
        <div className="headerDiv">
          <h1 className="h1">Välkommen till GodastFolkis.se 🍻!</h1>
          <h5 className="h5">
            <p>
              Sidan för dig som vill hitta den godaste folkisen, lättölen eller annan öl du hittar i en matbutik!
            </p>
          
            <div className="HelpIcon">
              <Button
                style={{ color: "black" }}
                startIcon={<HelpOutlineIcon fontSize="medium" />}
                onClick={handleClickOpen}
              ></Button>
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {"Om GodastFolkis.se!"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                      Denna hemsidan är enbart skapad som en rolig grej. Idén kom från att
                      jag skulle köpa öl på en röd lördag, och tänkte: "Fan, nu måste jag 
                      köpa folkisar till fotbollen... Vilken är godast egentligen?". Alla 
                      bedömningar är subjektiva och görs enskilt per öl som jag testar, ordningen
                      ölen visas i är till viss del efter vilken som är bäst. Smaken är som 
                      baken helt enkelt! 
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={handleClose}
                    autoFocus
                    variant="contained"
                    color="success"
                  >
                    Gött!
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          </h5>
        </div>
      </header>
      <nav>
        <div className="dropdown">
          <FormControl fullWidth>
            <InputLabel id="filter-select-label">Filtrera</InputLabel>
            <Select
              labelId="filter-select-label"
              id="filter-select"
              value={filter}
              label="Filtrera"
              onChange={handleChangeFilter}
            >
              <MenuItem value={"1"}>Alla</MenuItem>
              <MenuItem value={"2"}>Folkisar</MenuItem>
              <MenuItem value={"3"}>Lättisar</MenuItem>
              <MenuItem value={"4"}>Alkoholfria</MenuItem>
            </Select>
          </FormControl>
        </div>
        <div className="dropdown">
          <FormControl fullWidth>
            <InputLabel id="sort-select-label">Sortera</InputLabel>
            <Select
              labelId="sort-select-label"
              id="sort-select"
              value={sort}
              label="Sortera"
              onChange={handleChangeSort}
            >
              <MenuItem value={"0"}>Ingen sortering</MenuItem>
              <MenuItem value={"1"}>Betyg: Högst till Lägst</MenuItem>
              <MenuItem value={"2"}>Betyg: Lägst till Högst</MenuItem>
              
            { /* <MenuItem value={"3"}>Fem stjärnor</MenuItem>
              <MenuItem value={"4"}>Fyra stjärnor</MenuItem>
              <MenuItem value={"5"}>Tre stjärnor</MenuItem>
              <MenuItem value={"6"}>Två stjärnor</MenuItem>
              <MenuItem value={"7"}>En stjärna</MenuItem> 
              
              För möjlig framtida implementation
              
              */ }
          
            </Select>
          </FormControl>
        </div>
      </nav>
      <div>
        {/* För filtrering samt sortering */}
        <BeerCardsGallery
          selectedCategory={Number(filter)}
          selectedSort={Number(sort)}
        />
      </div>
      <footer>
        <div className="footerDiv">
          <p>Made by Dojjan 2024</p>
        </div>
      </footer>
    </div>
  );
};

export default App;
